// src/features/admissions/DischargeConfirm.tsx
import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import { useDischargeAdmission } from "../../apis/patients";

export default function DischargeConfirm({
  isOpen,
  onClose,
  admissionId,
  patientId,
}: {
  isOpen: boolean;
  onClose: () => void;
  admissionId: string;
  patientId: string;
}) {
  const [summary, setSummary] = useState("");
  const toast = useToast();
  const { mutate, isPending } = useDischargeAdmission(patientId);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Discharge patient</ModalHeader>
        <ModalBody>
          <Textarea
            placeholder="Discharge summary (optional)"
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} variant="ghost" mr={3}>
            Cancel
          </Button>
          <Button
            isLoading={isPending}
            colorScheme="red"
            onClick={() => {
              mutate(
                { admissionId, dischargeSummary: summary },
                {
                  onSuccess: () => {
                    toast({ status: "success", title: "Patient discharged" });
                    onClose();
                  },
                }
              );
            }}
          >
            Discharge
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
